import React from 'react';
import ProductForm from '../components/products/ProductForm';
import ProductTable from '../components/products/ProductTable';

export default function ProductsPage() {
    return (
        <div>
            <h1 className="h3 mb-4">Produtos</h1>
            <div className="row">
                <div className="col-lg-4 mb-4">
                    <ProductForm />
                </div>
                <div className="col-lg-8">
                    <ProductTable />
                </div>
            </div>
        </div>
    );
}
